<template>
    <div v-if="($route.query.type == 2 && $route.path !='/webenterpriseHlrj/login') 
    || $route.path =='/webenterpriseHlrj/homePage' 
    || $route.path =='/webenterpriseHlrj/cooperate'
    || $route.path =='/webenterpriseHlrj/newsInfo'
    || $route.path == '/webenterpriseHlrj/enhelpList'
    || $route.path == '/webenterpriseHlrj/enAbout'
    || $route.path == '/webenterpriseHlrj/jobHunting'
    || $route.path == '/webenterpriseHlrj/searchCert'
    || $route.path == '/webenterpriseHlrj/course'
    " 
    class="footerBar">
    <!-- pc 底部 -->
    <div class="pc-footer">
    <div class="ft-row flex">
        <div class="appPro">
            <div class="tit">产品中心</div>
            <div class="item"
             v-for="(item, index) in dataList"
            :key="index"
            v-if="index<4"
              @click="openView(item,1)"
            >{{item.appName}}</div>
        </div>
        <div class="appPro">
            <div class="tit">新闻动态</div>
            <div class="item"
             v-for="(item, index) in newList"
            :key="index"
            v-if="item.name !='未分类' && index  <4"
             @click="openView1(item)"
            >{{item.name}}</div>
        </div>
          <div class="appPro">
            <div class="tit">解决方案</div>
            <div class="item"
             v-for="(item, index) in dataList1"
            :key="index"
            v-if="index<4"
            @click="openView(item,2)"
            >{{item.name}}</div>
        </div>
         <div class="appPro">
            <div class="tit">关于我们</div>
            <!-- <div class="item">董事长致辞</div> -->
            <div class="item" @click="openAbout(6)">人才招聘</div>
          <div class="item" @click="openAbout(7)">了解和隆软件</div>
            <div class="item" @click="openAbout(8)">联系我们</div>
            <div class="item" @click="openAbout(9)">和隆官网</div>
        </div>
        <div class="homeQr ">
            <div class="homeQr-tit">
                <span> <i class="iconfont icon-al-headset-fill"></i> </span> 服务热线：400-8811-519
            </div>
             <div class="homeQr-tit">
                <span> <i class="iconfont icon-al-mail"></i> </span> 邮箱：hero@yhkz.com
            </div>
             <div class="homeQr-img flex align-cen">
                <p>  <i class="el-icon-star-on"></i> 关注我们：</p>
                <img src="../../assets/images/erweima.png" alt="">
             </div>
        </div>
    </div>
    <div class="ft-bot">
        <p>Copyright © 2014-2023北京和隆优化科技股份有限公司 版权所有</p>
        <p>京ICP备15057915</p>
        <p>技术支持：北京和隆软件有限公司</p>
    </div>
    </div>
    <!-- 移动端底部 -->
        <div class="mobile-footer">
            <div class="isIphone flex align-cen">
                <div class="isIphone-left flex align-cen">
                     <span> <i class="iconfont icon-al-headset-fill"></i> </span> 
                <div class="isIphone-text">
                    <div class="text">咨询热线</div>
                    <div class="num">400-8811-519</div>
                </div>
                </div>
                <div class="isIphone-right flex align-cen mft">
                     <span> <i class="iconfont icon-al-mail"></i> </span> 
                      <div class="isIphone-text">
                    <div class="text">邮箱</div>
                    <div class="num">hero@yhkz.com</div>
                </div>
                </div>
            </div>
            <!-- <div class="isSidebar">
                  <el-collapse 
                    v-model="activeName"
                    accordion
                    >
                      <el-collapse-item title="产品中心" name="1">
                        <ul class="isSidebar-item">
                            <li 
                        v-for="(item, index) in dataList"
                        :key="index"
                        v-if="index<4"
                        @click="openView(item,1)"
                            >
                            {{item.appName}}
                            </li>
                        </ul>
                      </el-collapse-item>
                      <el-collapse-item title="新闻动态" name="2">
                         <ul class="isSidebar-item">
                             <li 
                        v-for="(item, index) in newList"
                        :key="index"
                        v-if="index<4"
                        @click="openView(item,3)"
                            >
                            {{item.name}}
                            </li>
                        </ul>
                      </el-collapse-item>
                       <el-collapse-item title="解决方案" name="3">
                           <ul class="isSidebar-item">
                             <li 
                        v-for="(item, index) in dataList1"
                        :key="index"
                        v-if="index<4"
                        @click="openView(item,2)"
                            >
                            {{item.name}}
                            </li>
                        </ul>
                       </el-collapse-item>
                        <el-collapse-item title="关于我们" name="4">
                             <ul class="isSidebar-item">
                               <li class="item" @click="openAbout(6)">人才招聘</li>
                                <li class="item" @click="openAbout(7)">了解和隆优化</li>
                                    <li class="item" @click="openAbout(8)">联系我们</li>
                                    <li class="item" @click="openAbout(9)">资质荣誉</li>
                             </ul>
                        </el-collapse-item>
                             <el-collapse-item title="关注我们" name="5">
                                <div class="isSidebar-qc">
                                      <img src="../../assets/images/erweima.png" alt="" style="margin:0 auto;display:block">
                                </div>
                        </el-collapse-item>
                  </el-collapse>    
            </div> -->
         <div class="ft-bot">
        <p>Copyright © 2014-2023北京和隆优化科技股份有限公司 版权所有</p>
        <p>京ICP备15057915</p>
        <p>技术支持：南京睿首智能技术研究院</p>
    </div>
        </div>
    </div>
</template>
<script>
import { classList,ProductList,newList} from "@/api/enterprise/index" //分类，列表、新闻列表
import LocaStorage from "../../utils/localstorage.js"
export default {
    inject: ["reload"],
    name:'enterpriseFooter',
    data () {
        return {
            activeName:'',
            fristId:'',
            fristId1:'',
            dataList:[],
            newList:[],
            dataList1:[]
        }
    },
    created () {
             if((this.$route.query.type == 2 && this.$route.path !='/webenterpriseHlrj/login') 
       || this.$route.path =='/webenterpriseHlrj/homePage'
       || this.$route.path =='/webenterpriseHlrj/cooperate' 
       || this.$route.path =='/webenterpriseHlrj/newsInfo'
       || this.$route.path == '/webenterpriseHlrj/enhelpList'
       || this.$route.path == '/webenterpriseHlrj/enAbout'
       || this.$route.path == '/webenterpriseHlrj/jobHunting'
       || this.$route.path == '/webenterpriseHlrj/searchCert'
       ||this.$route.path == '/webenterpriseHlrj/course'
       ){
         this.getNewList()
        this.gethisList()
         this.gethisList1()
       }
           this.$bus.$off('footerReload')
                this.$bus.$on("footerReload", msg =>{ 
            this.getNewList()
        this.gethisList()
         this.gethisList1()
                })
    },
    methods: {
        // 打开关于我们
        openAbout(type){
          if(type == 5 || type == 7 || type == 8){
            this.$router.push({
                name:'enHlyhAbout',
                query:{
                    type:type
                }
            })
           }else if(type == 9){
            this.$router.push('/webenterprise/homePage')
           }
           else{
            this.$router.push('/webenterpriseHlrj/jobHunting')
           }
           this.$bus.$emit("fixedState",false);
            let token1 = LocaStorage.setAge().get('token1')
            if(token1){
                this.$bus.$emit("tokenStatus",true);
            }
            this.reload()
        },
                  // 打开页面
    openView(data,i){
      if(i == 1){
            const newurl = this.$router.resolve({name: 'endowloadHlyhDetail', query: {id: data.id,type:2}})
             window.open(newurl.href,'_blank')
            }else if(i == 2){
              if(data.contentType == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
               const newurl = this.$router.resolve({name: 'enHlyhSolution', query: {id: data.id,type:2}})
               window.open(newurl.href,'_blank')
             }
            }else{

            }
    },
            // 打开页面
    // openView(data,i){
    //     const newurl = this.$router.resolve({name: i == 1 ? 'endowloadHlyhDetail' : i == 2 ? 'enHlyhSolution' : 'enNewsHlyhDetail', query: {id: data.id,type:i == 3 ? 1 : 2}})
    //      window.open(newurl.href,'_blank')
    // },
    // 打开新闻
    openView1(data){
          if(data.type == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'enNewsHlyhDetail', query: {id: data.id}})
                window.open(newurl.href,'_blank')
             }
    },
        // 新闻
          getNewList(){
            newList({id:'',officialType:2},'enterprise')
            .then(res =>{
                this.newList = res.data
            })
        },
        gethisList(){
            ProductList({id:'',officialType:2},'enterprise',1)
            .then(res =>{
                this.dataList = res.data
            })
        },
        gethisList1(){
            ProductList({id:'',officialType:2},'enterprise',2)
            .then(res =>{
                this.dataList1 = res.data
            })
        }
        
    },
     destroyed(){
          this.$bus.$off('footerReload')
     }
}
</script>
<style lang="scss" scoped>
.mobile-footer{
    display: none;
}
.pc-footer{
    width: 100%;
    height: 320px;
    background: #252b3a;
    .ft-bot{
        text-align: center;
        color: rgba(255,255,255,.4);
        line-height: 25px;
        padding-top: 5px;
        font-size: 13px;
        margin-bottom: 20px;
    }
    .ft-row{
        width: 80vw;
        margin: 0 auto;
        justify-content: space-between;
        align-content: space-between;
        .appPro{
            padding-top: 30px;
            .tit{
                color: #fff;
                font-size: 22px;
                font-family: "Microsoft YaHei" !important;
                font-weight: 400;
            }
            .item{
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: 'Microsoft YaHei';
                color: rgba(255,255,255,.4);
                line-height: 30px;
                cursor: pointer;
            }
            .item:hover{
                color: #2893f1;
            }
        }
        .homeQr{
             padding-top: 30px;
             position: relative;
            color: #fff;
             .homeQr-tit{
                padding-top: 20px;
                cursor: pointer;
             }
            //  .homeQr-tit:hover{
            //      color: #2893f1;
            //  }
             .homeQr-img{
                padding-top: 20px;
                img{
                    width: 80px;
                }
             }
        }
        .homeQr::before{
            content: '';
            position: absolute;
            height: 168px;
            width: 1px;
            background: #FFFFFF;
            left: -40px;
            top: 50px;
        }
    }
}
@media (max-width: 640px){
    .pc-footer{
        display: none;
    }
    .mobile-footer{
        background: #252b3a;
        display: block; 
        width: 100%;
        .isIphone{
            padding: 19px 0 16px 15px;
            border-bottom: 1px solid #484646;
            .isIphone-right{
                margin-right: 15px;
            }
            span{
                i{font-size: 34px;}
                color: #BDBFC3;
                margin-right: 16px;
            }
            .isIphone-text{
                color: #fff;
                .text{
                    padding-bottom: 5px;
                }
            }
        }
        .el-collapse{
            border-top: none;
            border-bottom: 1px solid #484646;
            .isSidebar-item{
                padding: 0 45px;
                background: #252b3a;
                li{
                    font-size: 14px;
                    color: #fff;
                     line-height: 40px;
                }
            }
        }
        .ft-bot{
            text-align: center;
            color: #fff;
            font-size: 12px;
            margin: 20px 0;
        }
    }
}
::v-deep{
    @media (max-width: 640px){
        .el-collapse-item__wrap{
                background: #252b3a;
                border-bottom: 1px solid #484646;
            }
        .el-collapse-item__header{
             background: #252b3a;
             color: #fff;
             font-size: 16px;
             padding: 0 15px;
             border-bottom: 1px solid #484646;
             height: 60px;
           }
    }
}
</style>